import { render, staticRenderFns } from "./AddField.vue?vue&type=template&id=4665516c&scoped=true"
import script from "./AddField.vue?vue&type=script&lang=js"
export * from "./AddField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4665516c",
  null
  
)

export default component.exports